import { useState } from "react";
import { PhoneSettings } from "./customPropertyConfig";
import { MySwitch } from "../../shared/MySwitch";

type AppCustomPropertySettingsPhoneProps = {
    settings: PhoneSettings
    onChange: (settings: PhoneSettings) => void;
}

export const AppCustomPropertySettingsPhone = ({settings, onChange} : AppCustomPropertySettingsPhoneProps) => {
    return (
        <div className="app-custom-property-settings-container">

            

        </div>
    )
}